<!-- SIDE PANEL -->
<ng-container *ngIf="!bhConfig.layout.sidepanel.hidden && bhConfig.layout.sidepanel.position === 'left'">

    <!-- PANEL CONTENT -->

</ng-container>
<!-- / SIDE PANEL -->

<div id="main">

    <!-- TOOLBAR: Above fixed -->
    <ng-container *ngIf="bhConfig.layout.toolbar.position === 'above-fixed'">
        <ng-container *ngTemplateOutlet="toolbar"></ng-container>
    </ng-container>
    <!-- / TOOLBAR: Above fixed -->

    <div id="container-1" class="container" bhPerfectScrollbar
         [bhPerfectScrollbarOptions]="{suppressScrollX: true, updateOnRouteChange : true}">

        <!-- TOOLBAR: Above static -->
        <ng-container *ngIf="bhConfig.layout.toolbar.position === 'above-static'">
            <ng-container *ngTemplateOutlet="toolbar"></ng-container>
        </ng-container>
        <!-- / TOOLBAR: Above static -->

        <div id="container-2" class="container">

            <!-- NAVBAR: Left -->
            <ng-container *ngIf="bhConfig.layout.navbar.position === 'left'">
                <ng-container *ngTemplateOutlet="leftNavbar"></ng-container>
            </ng-container>
            <!-- / NAVBAR: Left -->

            <!-- CONTENT -->
            <content
                [ngClass]="{'ml-32':bhConfig.layout.navbar.position === 'left', 'mr-32':bhConfig.layout.navbar.position === 'right'}">
            </content>
            <!-- / CONTENT -->

            <!-- NAVBAR: Right -->
            <ng-container *ngIf="bhConfig.layout.navbar.position === 'right'">
                <ng-container *ngTemplateOutlet="rightNavbar"></ng-container>
            </ng-container>
            <!-- / NAVBAR: Right -->

        </div>

        <!-- FOOTER: Above static -->
        <ng-container *ngIf="bhConfig.layout.footer.position === 'above-static'">
            <ng-container *ngTemplateOutlet="footer"></ng-container>
        </ng-container>
        <!-- FOOTER: Above static -->

    </div>

    <!-- FOOTER: Above fixed -->
    <ng-container *ngIf="bhConfig.layout.footer.position === 'above-fixed'">
        <ng-container *ngTemplateOutlet="footer"></ng-container>
    </ng-container>
    <!-- FOOTER: Above fixed -->

</div>

<!-- SIDE PANEL -->
<ng-container *ngIf="!bhConfig.layout.sidepanel.hidden && bhConfig.layout.sidepanel.position === 'right'">

    <!-- PANEL CONTENT -->

</ng-container>
<!-- / SIDE PANEL -->

<!-- QUICK PANEL -->
<bh-sidebar name="quickPanel" position="right" class="quick-panel">
    <quick-panel></quick-panel>
</bh-sidebar>
<!-- / QUICK PANEL -->

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- @ PARTIALS                                                                                            -->
<!-- ----------------------------------------------------------------------------------------------------- -->

<!-- TOOLBAR -->
<ng-template #toolbar>
    <toolbar *ngIf="!bhConfig.layout.toolbar.hidden"
             [ngClass]="bhConfig.layout.toolbar.customBackgroundColor === true ? bhConfig.layout.toolbar.position + ' ' + bhConfig.layout.toolbar.background : bhConfig.layout.toolbar.position">
    </toolbar>
</ng-template>
<!-- / TOOLBAR -->

<!-- FOOTER -->
<ng-template #footer>
    <footer *ngIf="!bhConfig.layout.footer.hidden"
            [ngClass]="bhConfig.layout.footer.customBackgroundColor === true ? bhConfig.layout.footer.position + ' ' + bhConfig.layout.footer.background : bhConfig.layout.footer.position">
    </footer>
</ng-template>
<!-- / FOOTER -->

<!-- LEFT NAVBAR -->
<ng-template #leftNavbar>
    <bh-sidebar name="navbar" class="navbar-bh-sidebar"
                  [folded]="bhConfig.layout.navbar.folded"
                  lockedOpen="gt-md"
                  *ngIf="!bhConfig.layout.navbar.hidden">
        <navbar [variant]="bhConfig.layout.navbar.variant" class="left-navbar"></navbar>
    </bh-sidebar>
</ng-template>
<!-- / LEFT NAVBAR -->

<!-- RIGHT NAVBAR -->
<ng-template #rightNavbar>
    <bh-sidebar name="navbar" position="right" class="navbar-bh-sidebar"
                  [folded]="bhConfig.layout.navbar.folded"
                  lockedOpen="gt-md"
                  *ngIf="!bhConfig.layout.navbar.hidden">
        <navbar [variant]="bhConfig.layout.navbar.variant" class="right-navbar"></navbar>
    </bh-sidebar>
</ng-template>
<!-- / RIGHT NAVBAR -->
